import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ShieldCheck, Lock, CheckCircle2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Field, Coinciden } from "@/pages/Login";

const getToken = () => new URLSearchParams(window.location.search).get("token") || "";

export default function Restablecer() {
  const navigate = useNavigate();
  const [nueva, setNueva] = useState("");
  const [repite, setRepite] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const token = getToken();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (nueva.length < 8) return setError("La contraseña debe tener al menos 8 caracteres.");
    if (nueva !== repite) return setError("Las contraseñas no coinciden.");
    setBusy(true);
    try {
      await api.post("/auth/restablecer", { token, nueva });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md aldia-fade-up">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-[#3A6B56] flex items-center justify-center mx-auto">
            <ShieldCheck size={34} className="text-white" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-[#1C2421] mt-4">Nueva contraseña</h1>
        </div>

        {!token ? (
          <div className="bg-white border border-[#E5DFD5] rounded-2xl p-6 text-center">
            <p className="text-base text-[#B91C1C]">Enlace no válido.</p>
            <Link to="/recuperar" className="inline-block mt-4 font-bold text-[#3A6B56]">Solicitar uno nuevo</Link>
          </div>
        ) : done ? (
          <div className="bg-white border border-[#E5DFD5] rounded-2xl p-6 text-center" data-testid="restablecer-done">
            <CheckCircle2 size={44} className="text-[#16A34A] mx-auto" />
            <p className="text-base text-[#1C2421] mt-3">Contraseña actualizada. Te llevamos a iniciar sesión…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-[#E5DFD5] rounded-2xl p-6 shadow-sm space-y-4">
            <Field icon={Lock} label="Nueva contraseña (mínimo 8 caracteres)" type="password" value={nueva} onChange={setNueva} placeholder="Nueva contraseña" testid="restablecer-nueva" autoComplete="new-password" />
            <Field icon={Lock} label="Repite la contraseña" type="password" value={repite} onChange={setRepite} placeholder="Repite la contraseña" testid="restablecer-repite" autoComplete="new-password" invalido={!!repite && repite !== nueva} />
            <Coinciden a={nueva} b={repite} testid="restablecer-coinciden" />
            {error && <p data-testid="restablecer-error" className="text-sm font-semibold text-[#B91C1C] bg-[#FEF2F2] rounded-xl p-3">{error}</p>}
            <button data-testid="restablecer-submit" disabled={busy || !repite || repite !== nueva} className="w-full min-h-[56px] rounded-xl bg-[#3A6B56] text-white font-semibold text-lg hover:bg-[#2E5645] transition-colors disabled:opacity-60">
              {busy ? "Guardando…" : "Guardar nueva contraseña"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
